import React from "react";
import { Link, NavLink } from "react-router-dom";

function Navbar() {
  return (
    <header className="sticky top-0 z-40 border-b border-base-200 bg-base-100/85 backdrop-blur supports-[backdrop-filter]:bg-base-100/70">
      <nav className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
        <Link to="/" className="text-lg font-semibold tracking-tight">
          fotoGrafica
        </Link>
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            `-mr-3 rounded-full px-3 py-2 text-sm font-medium ${isActive ? "bg-base-200" : "hover:bg-base-200"}`
          }
        >
          Contact
        </NavLink>
      </nav>
    </header>
  );
}

export default Navbar;
